/**
 * MVアニメーションの設定用ファイル
 */

const slidesEl = document.querySelector('[data-carousel-get_slides]');

// スライドの情報を取得
export const SLIDES = JSON.parse(slidesEl.dataset.carouselGet_slides);
// スライド枚数
export const IMAGE_COUNT = SLIDES.length;

// =========================
// 設定用オブジェクト
// =========================
export const CONFIG = {
	// ブレークポイント
	breakpoint: 768,
	// 視野角
	cameraFovPc: 40,
	cameraFovSp: 19,
	// カメラポジション(z)
	cameraPositionZPc: 8,
	cameraPositionZSp: 14,
	// 傾き(x軸)
	tiltDegreeX: 3,
	// 傾き(y軸)
	tiltDegreeY: -7,
	// 傾き(z軸)
	tiltDegreeZ: -11,
	// 自動回転速度
	autoSpeedMin: 0.0005,
	autoSpeedMax: 0.1,
	// クリック後停止時間
	pauseDuration: 2000,
	// active判定補正
	activeOffset: 1,
	// ジオメトリの上面半径(PC)
	radiusTopPc: 6.3,
	// ジオメトリの下面半径(PC)
	radiusBottomPc: 6.3,
	// ジオメトリの上面半径(SP)
	radiusTopSp: 6,
	// ジオメトリの下面半径(SP)
	radiusBottomSp: 6,
	// スライドのアスペクト比
	aspectPc: 16 / 9,
	aspectSp: 5 / 3,
	// スライドの高さ(PC)
	slideHeightPc: {
		3: 2.6,
		4: 2.6,
		5: 2.3,
		6: 2.3
	},
	// スライドの高さ(SP)
	slideHeightSp: 2.7,
	// 追従速度
	rotationLeapSpeedPc: {
		3: 0.06,
		4: 0.06,
		5: 0.08,
		6: 0.1
	},
	rotationLeapSpeedSp: {
		3: 0.06,
		4: 0.06,
		5: 0.08,
		6: 0.1
	},
	// 回転位置
	slideShift: {
		3: 1.35,
		4: 2,
		5: 2.5,
		6: 3.1
	},
	// カルーセルの半径
	radiusPc: {
		3: 3.2,
		4: 3.2,
		5: 3,
		6: 2.8
	},
	radiusSp: {
		3: 3,
		4: 3,
		5: 3,
		6: 2.2,
	},
	// 切り出す円柱の度数の割合。大きいほどスライドの横幅が小さくなる
	arcFactorPc: 7.4,
	arcFactorSp: 7.4,
};
